"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.75c-3.127 0-5.672 2.675-5.672 5.963 0 2.314 2.739 7.13 4.371 9.795.285.464.771.742 1.3.742s1.015-.278 1.301-.743c1.633-2.664 4.371-7.48 4.371-9.794 0-3.288-2.545-5.963-5.672-5.963z"
}), 'MapPinFull');
//# sourceMappingURL=index.js.map